import { render } from "./WelcomePage.vue?vue&type=template&id=27270f29"
const script = {}

import "./WelcomePage.vue?vue&type=style&index=0&id=27270f29&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__